import { createSlice } from '@reduxjs/toolkit';
import {userSignupApi} from '../SignupApi/SignupApi';

const userSignUpSlice = createSlice({
  name: 'userSignUp',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(userSignupApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userSignupApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(userSignupApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default userSignUpSlice.reducer;
